import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-docarticle-menu',
    templateUrl: './docarticle-menu.component.html',
    styleUrls: ['./docarticle-menu.component.css'],
})
export class DocarticleMenuComponent {
    /**
     * The name of the documentation webpagemenu to load into generic webpagemnu component.
     */
    public webpageName = '';

    constructor(private state: StateService) {
        this.webpageName = this.state.getCurrentName();
    }
}
